function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBoxTruck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 2227 1161",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    xmlnsSerif: "http://www.serif.com/",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M145.791,1023.76l-108.882,-0c-9.789,-0 -19.177,-3.889 -26.098,-10.811c-6.922,-6.922 -10.811,-16.31 -10.811,-26.099l0,-126.85l270.484,0c-71.853,19.791 -124.693,85.653 -124.693,163.76Zm214.976,-163.76l1288.15,0l0,-511.287c0,-9.789 3.889,-19.177 10.811,-26.098c6.922,-6.922 16.31,-10.811 26.099,-10.811l254.863,0c36.285,0 70.267,17.778 90.959,47.584l175.475,252.771c12.871,18.541 19.769,40.573 19.769,63.144l-0,311.547c-0,9.789 -3.889,19.177 -10.811,26.099c-6.922,6.922 -16.31,10.811 -26.099,10.811l-85.059,-0c-0,-93.735 -76.101,-169.835 -169.835,-169.835c-93.734,0 -169.835,76.1 -169.835,169.835l-1279.79,-0c0,-78.107 -52.84,-143.969 -124.693,-163.76Zm1361.61,-438.724l-0,71.783c-0,29.367 11.666,57.531 32.431,78.297c20.766,20.765 48.93,32.431 78.297,32.431l253.773,0c4.121,0 7.902,-2.288 9.812,-5.94c1.91,-3.652 1.634,-8.062 -0.716,-11.447l-118.23,-170.311c-13.795,-19.871 -36.45,-31.723 -60.64,-31.723l-157.818,0c-9.789,0 -19.177,3.889 -26.099,10.811c-6.922,6.922 -10.81,16.31 -10.81,26.099Zm-100.762,-347.462l0,759.09l-1621.62,-0l0,-759.09c-0,-19.578 7.777,-38.354 21.621,-52.198c13.844,-13.844 32.62,-21.621 52.198,-21.621l1473.98,0c19.578,-0 38.354,7.777 52.197,21.621c13.844,13.844 21.621,32.62 21.621,52.198Zm313.47,812.883c75.647,-0 137.063,61.416 137.063,137.063c0,75.647 -61.416,137.063 -137.063,137.063c-75.647,0 -137.063,-61.416 -137.063,-137.063c-0,-75.647 61.416,-137.063 137.063,-137.063Zm-1619.46,-0c75.647,-0 137.063,61.416 137.063,137.063c-0,75.647 -61.416,137.063 -137.063,137.063c-75.648,0 -137.064,-61.416 -137.064,-137.063c0,-75.647 61.416,-137.063 137.064,-137.063Z",
    style: {
      fill: "#141f2a"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxTruck);
export default __webpack_public_path__ + "static/media/BoxTruck.7c90f73b8de7f39d7debaeb4be8fe97b.svg";
export { ForwardRef as ReactComponent };